import axios from 'axios';

const isLocalBrowser = typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
const inferredLocalBase = isLocalBrowser ? 'http://localhost:5000' : '';
const rawBase = process.env.REACT_APP_API_URL || inferredLocalBase;
// Normalize base: remove trailing slash and trailing '/api' if present
const normalizedBase = rawBase.replace(/\/$/, '').replace(/\/api$/, '');

const api = axios.create({
  baseURL: normalizedBase,
  timeout: 0, // No timeout - wait indefinitely for large file uploads
});

export const API_BASE = normalizedBase;
export default api;
